import { render, staticRenderFns } from "./HeadlineMetric.vue?vue&type=template&id=3de2a002&scoped=true"
import script from "./HeadlineMetric.vue?vue&type=script&lang=js"
export * from "./HeadlineMetric.vue?vue&type=script&lang=js"
import style0 from "./HeadlineMetric.vue?vue&type=style&index=0&id=3de2a002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de2a002",
  null
  
)

export default component.exports